import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../shared/services/user.service';
import {NavbarService} from '../shared/services/navbar.service';
import {IWGSharedService} from '../shared/services/shared.service';
import {DownloadService} from '../shared/services/download.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CommonService} from '../shared/services/common.service';

@Component({
  selector: 'app-my-talent-search',
  templateUrl: './my-talent-search.component.html',
  styleUrls: ['./my-talent-search.component.scss']
})
export class MyTalentSearchComponent implements OnInit {

  _timeout = null;
  _timeoutDuration = 500;
  _isAllowToChange = true;
  selectedServiceTypeId = 1;
  previousSortByColumnNameEOR = '';
  previousSortByColumnNameAOR = '';
  sortColumnName = '';
  sortColumnDirection = '';
  reverseSortEOR = false;
  reverseSortAOR = false;
  selectedRattingIds = [];
  selectedExperienceLevelIds = [];
  selectedCountryIds = [];
  selectedCandidateId = 0;
  selectedRegionId = 0;
  searchText = null;

  sortWorker =false;
  sortRatting=false;
  //showMore : boolean=false;

  ExperienceLevels = [];
  Rattings = [];
  CountriesList = [];
  AORSearchList = [];
  EORSearchList = [];

  AssignmentInformationList = [];
  WorkerInformation = null;
  candidateLabel = 'Worker';
  isLoading = false;
  selectedTab1 = 0;
  selectedTab2 = 0;
  selectedMainTab = 0;
  displayedColumns: string[] = ["CandidateNameCol","RatingLevelCol"];
  displayedColumns1: string[] = ["ContractorCol", "RatingCol"];

  constructor(private router: Router, private userService: UserService, private nav: NavbarService,
              private sharedService: IWGSharedService, private download: DownloadService,
              private toast: MatSnackBar, private commonService: CommonService) { }

  ngOnInit(): void {
    this.sortWorker =false;
    this.sortRatting=false;
    if (this.userService.getUser() === null) {
      this.router.navigate(['/login']);
      return;
    }
    this.nav.show();
    this.nav.setActiveMenu('my-talent');
    this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'my-talent'});
    this.isLoading = true;
    this.commonService.GetSearchSummary().subscribe((dropdownSummary: any) => {      
      if(!dropdownSummary.apiCallStatus){
        return;
      }
      dropdownSummary = dropdownSummary.data.Data;
      if (dropdownSummary.ServiceTypes) {
        this.ExperienceLevels = dropdownSummary.Designations;
        this.Rattings = dropdownSummary.RatingLevels;
        this.CountriesList = dropdownSummary.CountriesList;
      }
      this.isLoading = false;
    });
    this.searchSubmit();
   
  }

  ResetElements () {
    this.selectedServiceTypeId = 1;
    this.previousSortByColumnNameEOR = '';
    this.previousSortByColumnNameAOR = '';
    this.sortColumnName = '';
    this.sortColumnDirection = '';
    this.reverseSortEOR = false;
    this.reverseSortAOR = false;
    this.selectedRattingIds = [];
    this.selectedExperienceLevelIds = [];
    this.selectedCountryIds = [];
    this.selectedCandidateId = 0;
    this.selectedRegionId = 0;
    this.searchText = null;

    this.ExperienceLevels = [];
    this.Rattings = [];
    this.CountriesList = [];
    this.AORSearchList = [];
    this.EORSearchList = [];

    this.AssignmentInformationList = [];
    this.WorkerInformation = {};
    this.candidateLabel = 'Worker';
  }

  searchSubmit = () => {
    this._isAllowToChange = true;
    this.EORSearchList = [];
    this.AORSearchList = [];
    this.WorkerInformation = {};
    this.AssignmentInformationList = [];
    this.isLoading = true;
    let props = {
      rating_level_ids: this.selectedRattingIds ? this.selectedRattingIds.join(',') : '',
      designation_ids: this.selectedExperienceLevelIds ? this.selectedExperienceLevelIds.join(',') : '',
      country_ids: this.selectedCountryIds ? this.selectedCountryIds.join(',') : '',
      region_id: this.selectedRegionId,
      search_text: this.searchText,
      service_type_id: this.selectedServiceTypeId,
      sort_column_name: this.sortColumnName,
      sort_column_direction: this.sortColumnDirection
    };
    const prom = this.commonService.GetCandidatesRatingInfo(props).toPromise();
    prom.then(this.onSuccessSearchResult.bind(this), this.onSearchError.bind(this));
  }
  resetFilter = () => {
    this._isAllowToChange = false;
    // $scope.selectedServiceTypeId = 0;
    // $scope.selectedMainTab = 0;
    // Reset filters and call API to refresh the list.
    this.selectedRattingIds = [];
    this.selectedExperienceLevelIds = [];
    this.selectedCountryIds = [];
    this.searchText = null;

    this.selectedTab1 = 0;
    this.selectedTab2 = 0;
    this.searchSubmit();
  }
  downloadResume = (workerResumeFileID) =>
  {
    this.download.saveAs('/Api/File/' + workerResumeFileID).then(() =>
    {});
  }
  getAssignmentInfos = (selectedItem) => {
    this.isLoading = true;
    let props = {
      service_type_id: selectedItem.ServiceTypeId,
      candidate_id: selectedItem.CandidateId
    };
    this.selectedCandidateId = selectedItem.CandidateId;

    const prom = this.commonService.GetCandidatesAssignmentsInfo(props).toPromise();
    prom.then(this.onSuccessAssignmentIfos.bind(this), this.onSearchError.bind(this));
  }
  onSearchError(response) {    
    this.isLoading = false;
    alert('Error occured while processing your request.');
  }
  onTopNavChange = (serviceTypeId) => {
    this.selectedServiceTypeId = serviceTypeId;
    this.AssignmentInformationList = [];
    if (serviceTypeId == 1) {
      this.getEORAssignmentInfo();
    }
    if (serviceTypeId == 2) {
      this.getAORAssignmentInfo();
    }
  }
  onSuccessSearchResult(response) {
    response = response.data.Data;
    this.EORSearchList = response.EORSearchList;
    this.AORSearchList = response.AORSearchList;
    if (response.myTalentWorkerResultViewModel) {
      this.onSuccessAssignmentIfos(response.myTalentWorkerResultViewModel, true);
      if (response.myTalentWorkerResultViewModel.AssignmentDetailViewModelList.length > 0) {
        this.selectedCandidateId = response.myTalentWorkerResultViewModel.WokerDetailViewModel.WokerID;
      }
    }
    this.isLoading = false;
  }
  getEORAssignmentInfo() {
    if (this.EORSearchList && this.EORSearchList.length > 0) {
      var firstRowDetail = {
        ServiceTypeId: this.EORSearchList[0].ServiceTypeId,
        CandidateId: this.EORSearchList[0].CandidateId
      };
      this.getAssignmentInfos(firstRowDetail); //Get the file list detail.
    }
  }
  getAORAssignmentInfo() {
    if (this.AORSearchList && this.AORSearchList.length > 0) {
      var firstRowDetail = {
        ServiceTypeId: this.AORSearchList[0].ServiceTypeId,
        CandidateId: this.AORSearchList[0].CandidateId
      };
      this.getAssignmentInfos(firstRowDetail); // Get the file list detail.
    }
  }
  onSuccessAssignmentIfos(response, isParsed) {
    if (isParsed != true) {
      response = response.data.Data;
    }    
    this.isLoading = false;
    if (response.AssignmentDetailViewModelList) {
      this.AssignmentInformationList = response.AssignmentDetailViewModelList;
    }
    else {
      this.AssignmentInformationList = [];
    }
    if (this.WorkerInformation) {
      this.WorkerInformation = response.WokerDetailViewModel;
    }
    else {
      this.WorkerInformation = {};
    }    
  }
  sortListAOR = (sortByColumn) => {

    this.sortWorker =false;
    this.sortRatting=false;

    if(sortByColumn=='CandidateName'){
      this.sortWorker =true ;
    }
    else if(sortByColumn=='RatingLevel'){
      this.sortRatting=true;
    }
    
    this.selectedServiceTypeId = 2;
    if (sortByColumn != this.previousSortByColumnNameAOR) {
      this.reverseSortAOR = true;
    } else {
      this.reverseSortAOR = !this.reverseSortAOR;
    }
    this.previousSortByColumnNameAOR = sortByColumn;
    this.sortColumnName = sortByColumn;
    if (this.reverseSortAOR == false) {
      this.sortColumnDirection = 'DESC';
    } else {
      this.sortColumnDirection = 'ASC';
    }
    this.searchSubmit();
  }
  sortListEOR = (sortByColumn) => {

    this.sortWorker =false;
    this.sortRatting=false;

    if(sortByColumn=='CandidateName'){
      this.sortWorker =true ;
    }
    else if(sortByColumn=='RatingLevel'){
      this.sortRatting=true;
    }

    
    this.selectedServiceTypeId = 1;
    if (sortByColumn != this.previousSortByColumnNameEOR) {
      this.reverseSortEOR = true;
    } else {
      this.reverseSortEOR = !this.reverseSortEOR;
    }
    this.previousSortByColumnNameEOR = sortByColumn;
    this.sortColumnName = sortByColumn;
    if (this.reverseSortEOR == false) {
      this.sortColumnDirection = 'DESC';
    } else {
      this.sortColumnDirection = 'ASC';
    }
    this.searchSubmit();
  }
  getSearchResultOnScopeChanges() {
    if (!(this._isAllowToChange)) {
      // Don't call API when there is an on-change from clear filters.
      return;
    }
    if (this._timeout) { // if there is already a timeout in process cancel it
      clearTimeout(this._timeout);
    }
    this._timeout = setTimeout(() => {      
      this._timeout = null;
      this.searchSubmit();
    }, this._timeoutDuration);
  }
moreClick(showMore){
showMore=!showMore;
return showMore;
}
onTabChanged(event){  
  this.AssignmentInformationList = [];
    if (event.index == 0) {
      this.selectedServiceTypeId = 1;
      this.getEORAssignmentInfo();
    }
    if (event.index == 1) {
      this.selectedServiceTypeId = 2;
      this.getAORAssignmentInfo();
    }
}

loadMytalentrate = () => {
    this.router.navigate(['/my-talent-rate']);
}

}
